/* eslint-disable */
import { Component } from 'react';

import './site-loader.css';

class SiteLoader extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      marginTop: this.calcMarginTop()
    };
    
    this.setMarginTop = this.setMarginTop.bind(this);
  }
  
  calcMarginTop() {
    return window.innerHeight / 2 - 100;
  }
  
  setMarginTop() {
    this.setState({marginTop: this.calcMarginTop()});
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.setMarginTop);
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.setMarginTop);
  }
  
  render() {
    const style = {
      marginTop: this.state.marginTop,
    };

    return (
      <div className="preloader">
        <div className="preloader-overlay">
          <div className="preloader-content" id="preloader-content" style={style}>
            <span className="fa fa-cog fa-spin fa-3x fa-fw"/>
            <h4>Please Wait!</h4>
            <h5>Loading Content</h5>
          </div>
        </div>
      </div>
    );
  }
};

export default SiteLoader;
